import type {
  PublicTrip,
  PublicTripV4
} from "@busbud/core-types/dist/lib/poll-service/api";

import type { LegIndex } from "@app/constants/trip";
import { RETURN_LEG_INDEX } from "@app/constants/trip";

import { isRoundtrip } from "./is-roundtrip";

export function throwsIfAccessingReturnLegOfOnewayTrip(
  trip: PublicTrip | PublicTripV4,
  leg_index: LegIndex
) {
  if (!isRoundtrip(trip) && leg_index === RETURN_LEG_INDEX) {
    throw new Error("Trying to access the return leg of a oneway trip");
  }
}
